export function getPageInfo() {
    const urlParams = new URLSearchParams(window.location.search);
    let language = window.navigator.language.startsWith('de') ? 'de' : 'en';

    if (window.location.pathname.startsWith('/de')) {
        language = 'de';
    } else if (window.location.pathname.startsWith('/en')) {
        language = 'en';
    }

    const page = window.location.pathname.endsWith('/sign-up') ? 'SignUp' : 'SignIn';

    return {
        language,
        page,
        email: urlParams.get('email'),
        team: urlParams.get('team'),
        redirect: urlParams.get('redirect')
    };
}
